import type * as React from "react";
import type { SvgIconProps } from "./types";

export function resolveIconSize(
  size: number | undefined,
  defaultWidth: number,
  defaultHeight: number
) {
  if (!size) return { width: defaultWidth, height: defaultHeight };
  const ratio = defaultHeight / defaultWidth;
  return { width: size, height: Math.round(size * ratio) };
}

export function resolveA11yProps(
  props: SvgIconProps
): Pick<React.SVGProps<SVGSVGElement>, "role" | "aria-hidden"> {
  const ariaLabel = props["aria-label"];
  const ariaLabelledBy = props["aria-labelledby"];

  const hasLabel = typeof ariaLabel === "string" && ariaLabel.length > 0;
  const hasLabelledBy =
    typeof ariaLabelledBy === "string" && ariaLabelledBy.length > 0;
  const hasTitle = typeof props.title === "string" && props.title.length > 0;

  if (hasLabel || hasLabelledBy || hasTitle)
    return { role: "img", "aria-hidden": undefined };

  return { role: undefined, "aria-hidden": true };
}
